/*
 * @Description: 团餐数据大屏路由
 * @Author: xiawenlong
 * @Date: 2021-04-20 10:44:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2026-02-28 08:30:00
 */
export default [
  {
    path: '/tc',
    name: 'DatavTc',
    component: () => import('@/components/datav-tc/index.vue'),
    meta: {
      title: '团餐数据大屏',
    },
  },
]
